export function isAuthenticated() {
    try {
        const token = localStorage.getItem('token');
        return !!token;
    } catch (error) {
        console.error('Auth check error:', error);
        return false;
    }
}

export function getToken() {
    try {
        return localStorage.getItem('token');
    } catch (error) {
        console.error('Get token error:', error);
        return null;
    }
}

export function getUserData() {
    try {
        const userData = localStorage.getItem('user');
        return userData ? JSON.parse(userData) : null;
    } catch (error) {
        console.error('Get user data error:', error);
        return null;
    }
}

export function updateUserData(newData) {
    try {
        const currentData = getUserData();
        if (!currentData) {
            throw new Error('No user data found');
        }
        
        const updatedData = {
            ...currentData,
            ...newData
        };
        
        localStorage.setItem('user', JSON.stringify(updatedData));
        return updatedData;
    } catch (error) {
        console.error('Update user data error:', error);
        throw error;
    }
}

export function logout() {
    try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
    } catch (error) {
        console.error('Logout error:', error);
    }
}

export function requireAuth(Component) {
    try {
        if (!isAuthenticated()) {
            window.location.href = '/auth';
            return null;
        }
        return Component;
    } catch (error) {
        console.error('Auth requirement check error:', error);
        return null;
    }
}
